/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from 'primeng/api';

/**
 * This pipe can be used to transform an array of string enum values to conform to the interface required
 * by the PrimeNG SelectItem (used in Dropdowns etc).
 *
 * Example usage: <p-dropdown... [options]="getAllEnumPossibleValues() | formatSelectItemEnum" ...>.
 */

@Pipe({
  name: 'formatSelectItemEnum',
})
@Injectable()
export class FormatSelectItemEnumPipe implements PipeTransform {
  transform(value: any[]): SelectItem[] {
    if (value) {
      return value.map(function (item) {
        return {
          value: item,
          label: item,
        };
      });
    }
    return [];
  }
}
